import { sellerConstants } from '../../_constants/seller.constants';
import { creditService } from '../../_services/';

export const creditListActions = {
    getCreditList
};

function getCreditList(id) {
    return dispatch => {
        dispatch(request());
        creditService.getCreditList(id)
            .then(
                credits => {
                    dispatch(success(credits));
                },
                error => {
                    dispatch(failure(error));
                }
            );
    };

    function request() { return { type: sellerConstants.REQUEST_CREDITS} }
    function success(credits) { return { type: sellerConstants.RECEIVE_CREDITS, credits } }
    function failure(error) { return { type: sellerConstants.CREDITS_ERROR, error } }
}


// WEBPACK FOOTER //
// ./src/_actions/sellers/creditlist.actions.js